import script from "./StartGuide.vue?vue&type=script&setup=true&lang=ts"
export * from "./StartGuide.vue?vue&type=script&setup=true&lang=ts"

import "./StartGuide.vue?vue&type=style&index=0&id=caa38596&lang=scss"

const __exports__ = script;

export default __exports__